import React from 'react';

import './index.scss';

//material-ui
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';

//custom components
import CustomButton from '../../../../components/basic/CustomButton';
import CustomSnackbar from '../../../../components/global/snackbar';

//api
import {api} from '../../../../functions/api';

//other libraries
import ReactQuill from 'react-quill'
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';

const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class ProductContent extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            loadingBtn: false,
            message: "",
            openSnackbar: false,
            editorHtml: '' || toJS(this.props.internal.dataForSimpeTable.description),
            seoDescription: "" || toJS(this.props.internal.dataForSimpeTable.seo_description),
        }
        this.handleChange = this.handleChange.bind(this)
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    closeSnackBar() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({ message: "", openSnackbar: false })
        }, TIMEOUT)
    }
    
    handleChange (html) {
        this.setState({ editorHtml: html });
    }

    handleChangeSeoDescription = (seo) => {
        this.setState({seoDescription: seo.target.value})
    }

    handleSaveChanges = () => {
        this.chageData();
    }

    chageData = async() => {
        this.setState({loadingBtn: true})
        let update_data = await api({
            method: 'patch',
            url: 'products/' + this.props.routerData.match.params.idProduct,
            authorization: this.props.internal.user.access_token,
            params: {
                description: this.state.editorHtml,
                seo_description: this.state.seoDescription,
            }
        })

        if (update_data.success && update_data.success === true) {
            this.setState({message: update_data.data.message, openSnackbar: true})
            this.props.internal.setDataForSimpeTable(update_data.data.data)
        }
        if(update_data.data.error === true) {
            let resultMsg = ""
            for(let error in update_data.data.data.errors) {
                resultMsg += update_data.data.data.errors[error]
            }
            this.setState({message: resultMsg, openSnackbar: true})
        }

        this.closeSnackBar();
        this.setState({loadingBtn: false})
    }

    
    
    modules = {
        toolbar: [
            ['bold', 'italic', 'underline'], // 'strike', 'blockquote'
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{'list': 'ordered'}, {'list': 'bullet'}], // {'indent': '-1'}, {'indent': '+1'}
            [{ "size": [ 'small', false, 'large', 'huge' ]}],
            [{"color": []}, {background: []}],
            [{"align": []}],
            ['link']
        ],
        clipboard: {
          // toggle to add extra line breaks when pasting HTML:
            matchVisual: false,
        }
      }
      /*
       * Quill editor formats
       * See https://quilljs.com/docs/formats/
       */
    formats = [
        'bold', 'italic', 'underline',
        'header',
        'list', 'bullet',
        'size',
        'color',
        'background',
        'align',
        'link'
    ]

    render () {
        return (
            <div className={'container-edit-content'}>
            <Paper className={'edit-tab'}>
                <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                <div className={'flex space-between first-line'}>
                    <h1>{this.props.translate.i18n.MODULES.PRODUCTS.PRODUCT_CONTENT}</h1>
                    <CustomButton
                            progressBar={this.state.loadingBtn}
                            mystyle = {'btn-orange-bg '}
                            title = {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                            onClick = {this.handleSaveChanges}
                            justText
                            />
                </div>
                <ReactQuill
                    theme="snow"
                    onChange={this.handleChange}
                    value={this.state.editorHtml}
                    modules={this.modules}
                    formats={this.formats}
                    bounds={'.app'}
                    placeholder={this.props.placeholder}
                    
                />
                <span className={'seo-title'}>{this.props.translate.i18n.MODULES.PRODUCTS.SEO_DESCRIPTION}</span>
                <TextField
                    id="standard-bare"
                    onChange={this.handleChangeSeoDescription}
                    defaultValue={this.state.seoDescription}
                    className={'w-100 seo-description'}
                    placeholder={this.props.translate.i18n.MODULES.PRODUCTS.SEO_DESCRIPTION_PLACEHOLDER}
                    multiline={true}
                />
                <div className={'save-content-btn'}>
                
                </div>
            </Paper>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/screens/products/edit/content/index.js